import { render } from "./menu-teaser.vue?vue&type=template&id=6cbf0530"
import script from "./menu-teaser.vue?vue&type=script&lang=js"
export * from "./menu-teaser.vue?vue&type=script&lang=js"

import "./menu-teaser.vue?vue&type=style&index=0&id=6cbf0530&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__